import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import DealLeads from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/DealLeads';
import { LEAD_ROLE } from '@/creditflowresearch/ui/common/components/TableCells/DealLeads/leadRoles';

interface ICorporateLeadsProps extends ICellProps {
  limit?: number,
}

const CorporateLeads = ({ row, limit }: ICorporateLeadsProps) => (
  <DealLeads
    groups={ [
      { role: LEAD_ROLE.left, leads: row.leftLeads },
      { role: LEAD_ROLE.active, leads: row.activeLeads },
      { role: LEAD_ROLE.joint, leads: row.jointLeads },
    ] }
    limit={ limit }
    fallbackQuery={ { products: row.product?.abbreviation, regions: row.region?.abbreviation } }
  />
);

export default CorporateLeads;
